import React from 'react';
import { connect } from 'react-redux';
import { createActions } from '../../../store';
import SliderListItem from '../../../../../list-items/SliderListItem';
import { previewHistoryBatch } from '../../../store/extensions';
import { WAVE_STYLE, BAR_COUNT_STEP, MIN_BAR_COUNT, MAX_BAR_COUNT } from '../../../Preview/PreviewDisplayConstants';

const getBarCountLimits = (reflectionType) => {
    return {
        step: BAR_COUNT_STEP[reflectionType] || 1,
        min: MIN_BAR_COUNT[reflectionType] || 4,
        max: MAX_BAR_COUNT[reflectionType] || 200
    };
};

const VisualizerPointCountListItem = (props) => {
    const {visualizerBarCount, updateVisualizerSettings, visualizerWaveStyle, visualizerReflectionType } = props;
    const { step, min, max } = getBarCountLimits(visualizerReflectionType);
    const onCountChange = (value) => {
        previewHistoryBatch.start();
        updateVisualizerSettings({ barCount: value });
    };
    
    return (
        <SliderListItem
            title={visualizerWaveStyle === WAVE_STYLE.BAR ? 'Bar Count' : 'Point Count'}
            value={visualizerBarCount}
            displayMultiplier={1}
            min={min}
            max={max}
            step={step}
            onValueChange={onCountChange}
            toolTip={visualizerWaveStyle === WAVE_STYLE.SOLID ? 'The number of points used to draw the wave.' : null}
        />
    );
};

const mapStateToProps = (state) => {
    const { 
        barCount: visualizerBarCount,
        waveStyle: visualizerWaveStyle,
        reflectionType: visualizerReflectionType
    } = state.createPreview.present.videoSettings.visualizer;

    return { 
        visualizerBarCount, 
        visualizerWaveStyle,
        visualizerReflectionType
    };
}

const mapDispatchToProps = (dispatch) => {
    const updateVisualizerSettings = (properties) => dispatch(createActions.updateVisualizerSettings(properties));
    return { updateVisualizerSettings }
}

export default connect(mapStateToProps, mapDispatchToProps)(VisualizerPointCountListItem);